// React Native entry. Kept separate from the core so the core stays free of
// react-native / expo-router and tests in Node.
export { amplitudeDestination } from "./amplitude-destination";
export { useAppLifecycleAnalytics } from "./use-app-lifecycle-analytics";
export { useRouteAnalytics } from "./use-route-analytics";
